(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["discovery-hero"]) return;
  try {
    
	// FIXME: this logic could and should be improved, there are a lot of magic numbers in here

	window.addEventListener('load', function () {
		const section = document.querySelector('.discovery-hero');
		const image = section?.querySelector('.discovery-hero__image');

		if (!image || !section) return;
		const initialRadius = 12;
		const safeTimeout = 500;
		let offset = 0;
		let refH1Top = 0;
		let refH1Bottom = 0;

		function calculateOffsets() {
			image.classList.add('is-visible');
			const h1Element = section.querySelector('.discovery-hero__heading-1 h1');
			if (!h1Element) return;

			const h1ElementTop = h1Element.children[0];
			const h1ElementBottom = h1Element.children[1];
			if (!h1ElementTop || !h1ElementBottom) return;

			const parentRect = h1Element.getBoundingClientRect();
			const topRect = h1ElementTop.getBoundingClientRect();
			const bottomRect = h1ElementBottom.getBoundingClientRect();

			if (topRect && bottomRect && parentRect) {
				refH1Top = topRect.top - parentRect.top + topRect.height;
				refH1Bottom = parentRect.bottom - bottomRect.bottom + bottomRect.height;
				offset = (bottomRect.top - topRect.top - topRect.height) / 4;
			}
		}

		function handleScroll() {
			// const initialTopInset = (window.innerHeight - 300) / 2;
			const initialTopInset =
				refH1Top + offset ?? (window.innerHeight - 300) / 2;
			const initialBottomInset =
				refH1Bottom + offset ?? (window.innerHeight - 300) / 2;
			const initialSideInset = Math.max((window.innerWidth - 600) / 2, 30);
			const scrollY = window.scrollY;
			const sectionTop = section.offsetTop;
			const sectionHeight = section.offsetHeight;
			const totalScroll = sectionTop + sectionHeight - window.innerHeight;
			const progress = Math.min(Math.max(scrollY / totalScroll, 0), 1);

			const top = initialTopInset * (1 - progress);
			const bottom = initialBottomInset * (1 - progress);
			const side = initialSideInset * (1 - progress);
			const radius = initialRadius * (1 - progress);

			image.style.clipPath = `inset(${top}px ${side}px ${bottom}px ${side}px round ${radius}px)`;

			progress == 1
				? section.classList.add('is-fin')
				: section.classList.remove('is-fin');
		}

		function init() {
			setTimeout(() => {
				calculateOffsets();
				handleScroll();
			}, safeTimeout);
		}
		window.addEventListener('scroll', handleScroll);
		window.addEventListener('resize', init);
		init();
	});

  } catch(e) { console.error(e); }
})();
})();
